<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction/>
      <div class="section-body">
        
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="false"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/userBuildForm"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "",
  access_code: "F_LIST05",
  icon: "far fa-copy fa-fw",
  hidden:true,
  excludeSideBar:true,
  components: {},
  order:5,
  data() {
    return {
      gridId: "list05",
      formData: {
      
      }
    };
  },
  created() {
    if(this.$route.params.id){
      api.request(
        this,
        "post",
        `/userBuildForm/getIsworkFormName`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
            Parameters: {
            isworkID: this.$route.params.id
          }
        },
        function(r) {
          this.$route.meta.title = r.data.formName;
          console.log(r.data.formName);
        },
        function(r) {
          
        },
        null
      );
    }else{
      console.log('you press too fast');
    }
  },
  computed: {

   
    ...mapGetters("grid", ["getGridById"]),
    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    }
     

  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"])
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>